<template>
  <div>
<div class='container'>
<div class='total'>合计</div>
<div class='item-container'>
  <div class='item' v-for='(item,index) in summaryList' :key="index">
    <span class='title'>{{item.title}}:</span>
    <span class='value'>{{item.value}}</span>
  </div>
</div>
</div>
  </div>
</template>

<script>
export default {
  name: 'SummaryList',
  props: {
    summaryList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="less" scoped>
.container{
  display: flex;
  .total{
    margin-right: 8px;
  }
  .item-container{
  display: flex;

  }
}
</style>
